import { useState, useEffect } from 'react';
import { Typography, IconButton } from "@mui/material";
import { Navigate } from "react-router-dom";
import { Search, ManageAccounts } from "@mui/icons-material";
import { useAccountInfoFlag, useSearchFlag } from "./headerFlag";

export function HeaderToAccountInfo() {
    const headerToAccountInfoFlag = useAccountInfoFlag();
    const [toAccountInfoFlag, setToAccountInfoFlag] = useState<boolean>(false);

    //画面遷移後、フラグをすぐ戻す
    useEffect(() => {
        if (!toAccountInfoFlag) return;
        setToAccountInfoFlag(false);
    }, [toAccountInfoFlag]);

    return (
        <>
            {headerToAccountInfoFlag && (
                <>
                    {toAccountInfoFlag && <Navigate to="/account" replace />}
                    <Typography variant='body1'>アカウント変更</Typography>
                    <IconButton sx={{ color: "#01CFBE" }} aria-label="menu" onClick={() => setToAccountInfoFlag(true)}><ManageAccounts /></IconButton>
                </>
            )}
        </>
    );
}

export function HeaderToSearch() {
    const headerToSearchFlag = useSearchFlag();
    const [toSearchFlag, setToSearchFlag] = useState<boolean>(false);

    //画面遷移後、フラグをすぐ戻す
    useEffect(() => {
        if (!toSearchFlag) return;
        setToSearchFlag(false);
    }, [toSearchFlag]);

    return (
        <>
            {headerToSearchFlag && (
                <>
                    {toSearchFlag && <Navigate to="/search" replace />}
                    <Typography variant='body1'>検索条件入力画面</Typography>
                    <IconButton sx={{ color: "#01CFBE" }} aria-label="menu" onClick={() => setToSearchFlag(true)}><Search /></IconButton>
                </>
            )}
        </>
    );
}